// tenant-id.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class HttpinterceptorService implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    let body = req.body;
    const modifiedRequest = req.clone({
      setHeaders: {
        'X-Tenant-Id': environment.tenantId,
        // 'Content-Type': 'application/json',
        COUNTRY: 'MY',
        masterGroupCode: 'MY_MASTER',
        groupCode: environment.groupCode,
        ADTYPE: 'EYB2C',
      },
      body: body
    });

    return next.handle(modifiedRequest);
  }
}
